import { FC, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';

import { Button, ButtonProps, theme, Tooltip } from 'antd';

import CopiedIcon from 'assets/images/icons/copied.svg?react';
import CopyIcon from 'assets/images/icons/copy.svg?react';

interface ICopyButtonProps extends ButtonProps {
	text: string;
	tooltipText?: string;
	textMode?: boolean;
	copyText?: string;
	copiedText?: string;
	onCopied?: (copied: boolean) => void;
	withoutTooltip?: boolean;
}

export const CopyButton: FC<ICopyButtonProps> = ({
	text,
	icon = <CopyIcon />,
	tooltipText,
	textMode,
	copyText,
	copiedText,
	onCopied,
	withoutTooltip,
	...props
}) => {
	const { t } = useTranslation();
	const {
		token: { colorSuccess },
	} = theme.useToken();
	const [copied, setCopied] = useState(false);

	return (
		<CopyToClipboard
			text={text}
			onCopy={() => {
				setCopied(true);
				onCopied?.(true);
				setTimeout(() => {
					setCopied(false);
					onCopied?.(false);
				}, 3000);
			}}>
			<Tooltip
				title={
					textMode || withoutTooltip
						? undefined
						: copied
							? copiedText || t('Скопировано!')
							: tooltipText || copyText || t('Скопировать')
				}
				overlayStyle={{ maxWidth: 260 }}>
				<Button {...props} icon={textMode ? undefined : copied ? <CopiedIcon style={{ color: colorSuccess }} /> : icon}>
					{textMode ? (copied ? copiedText || t('Скопировано!') : copyText || t('Скопировать')) : null}
				</Button>
			</Tooltip>
		</CopyToClipboard>
	);
};
